import React from 'react';
import { connect } from 'react-redux';
import { Button, Icon } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { updateUsersFlags } from '../actions';
import { userState } from '../constants';

const UsersFilterToggles = ({
  category,
  approvedFlag,
  archivedFlag,
  unapprovedFlag,
  updateFlags,
}) => {
  const intl = useIntl();
  return (
    <Button.Group icon compact size="small">
      <Button
        active={archivedFlag}
        toggle
        className="aridhia-archived-users-button"
        data-tooltip={intl.formatMessage({ id: `users.state.filter.${userState.ARCHIVED}` })}
        data-position="left center"
        onClick={() => updateFlags(category, approvedFlag, unapprovedFlag, !archivedFlag)}
      >
        <Icon
          name="archive"
          alt={intl.formatMessage({ id: `users.state.filter.${userState.ARCHIVED}` })}
        />
      </Button>
      <Button
        active={approvedFlag}
        toggle
        className="aridhia-approved-users-button"
        data-tooltip={intl.formatMessage({ id: `users.state.filter.${userState.APPROVED}` })}
        data-position="left center"
        onClick={() => updateFlags(category, !approvedFlag, unapprovedFlag, archivedFlag)}
      >
        <Icon
          name="thumbs up"
          alt={intl.formatMessage({ id: `users.state.filter.${userState.APPROVED}` })}
        />
      </Button>
      <Button
        active={unapprovedFlag}
        toggle
        className="aridhia-unapproved-users-button"
        data-tooltip={intl.formatMessage({ id: `users.state.filter.${userState.UNAPPROVED}` })}
        data-position="left center"
        onClick={() => updateFlags(category, approvedFlag, !unapprovedFlag, archivedFlag)}
      >
        <Icon
          name="thumbs down"
          alt={intl.formatMessage({ id: `users.state.filter.${userState.UNAPPROVED}` })}
        />
      </Button>
    </Button.Group>
  );
};

const mapStateToProps = ({
  auth: { users },
}, { category }) => {
  const item = users[category];

  return ({
    approvedFlag: item.approvedFlag,
    archivedFlag: item.archivedFlag,
    unapprovedFlag: item.unapprovedFlag,
  });
};

const mapDispatchToProps = {
  updateFlags: updateUsersFlags,
};

export default connect(mapStateToProps, mapDispatchToProps)(UsersFilterToggles);
